<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>Fikiria Stock</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="5">
            <v-file-input class="mt-2" name="productExcelFile" v-model="excelFile" label="Browse Codes Excel Sheet"
              outlined dense></v-file-input>
          </v-col>

          <v-col cols="12">
            <!-- excel icon -->
            <download-excel :data="productCodes" :fields="fields" name="Stock List">
              <v-icon color="green">mdi-file-excel</v-icon>
            </download-excel>
            <!-- end -->
          </v-col>

          <v-col cols="12">
            <v-btn color="primary" :loading="loader" @click="uploadFikiriaExcel">
              <v-icon left>mdi-upload</v-icon>Upload Fikiria Stock
            </v-btn>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="8">
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
              hide-details></v-text-field>
          </v-col>
        </v-row>

        <v-row class="subtitle-2 text--primary">

          <v-col cols="12">
            <v-data-table :headers="headers" :items="productCodes" :search="search" :items-per-page="1000">
            </v-data-table>
          </v-col>
        </v-row>

      </v-card-text>
    </v-card>
    <!-- snackbar -->


    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  components: {},
  data: () => ({
    selectedCustomer: null,
    searchCustomers: null,
    headers: [
      { text: "Product Name", value: "Name" },
      { text: "Stock Before", value: "StockBefore" },
      { text: "Stock After", value: "StockAfter" },
      { text: "Variance", value: "Variance" },
    ],
    editItem: {},
    editDialog: false,
    customers: [],
    productCodes: [],
    search: "",
    loader: false,
    excelFile: null,
    date: null,
    fields: {
      Name: "Name",
      StockBefore: "StockBefore",
      StockAfter: "StockAfter",
      variance: "Variance",
    },
  }),
  watch: {
    searchCustomers(val) {
      if (val && val !== this.select && this.queryCustomers(val)) {
        this.queryCustomers(val);
      }
    }
  },
  methods: {
    setDate(myDate) {
      this.date = myDate;
    },
    getProductCodes() {
      const self = this;
      this.$store
        .dispatch("get", `/get-fikiria-stock`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.productCodes = res.ResponseData;
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    uploadFikiriaExcel() {
      const self = this;
      const data = new FormData();

      data.append("documentData", this.excelFile);
      // this.$store.commit("btnLoader", true);
      self.loader = true;
      const url = "/import-fikiria-stock";
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.$refs.snackbar.show("Products imported successfully", "green");
            // self.$store.commit("btnLoader", false);
            self.loader = false;
            self.excelFile = null;
          } else {
            // self.$store.commit("btnLoader", false);
            self.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getProductCodes();
  }
};
</script>